/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export enum ResponseError {
  NO_LONGER_VALID = 'JaloObjectNoLongerValidError',
  INVALID_ENTITY = 'EntityValidationError',
}
